import { render, staticRenderFns } from "./WeHelpSection.vue?vue&type=template&id=2b201527&scoped=true"
import script from "./WeHelpSection.vue?vue&type=script&lang=ts"
export * from "./WeHelpSection.vue?vue&type=script&lang=ts"
import style0 from "./WeHelpSection.vue?vue&type=style&index=0&id=2b201527&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b201527",
  null
  
)

export default component.exports